import { InjectionToken } from '@angular/core';
import { VehiclesService } from '../../modules/admin/vehicles/vehicles.service';
import { VehicleCategoriesService } from '../../modules/admin/vehicle-categories/vehicle-categories.service';
import {
	ApiPaginatedResponse,
	ApiRequestOrdering,
	ApiRequestPagination,
	VehicleCategoryFeatureItemDto,
	VehicleCategoryFeatureItemsFilters,
	VehicleFeatureItemDto,
	VehicleFeatureItemsFilters,
} from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';

export interface ExtraFeatureItemsProvider {
	getExtraFeatureItems(
		filters?: VehicleFeatureItemsFilters | VehicleCategoryFeatureItemsFilters,
		pagination?: ApiRequestPagination,
		ordering?: ApiRequestOrdering,
	): Observable<
		ApiPaginatedResponse<
			VehicleFeatureItemDto[] | VehicleCategoryFeatureItemDto[]
		>
	>;
}

export const VEHICLES_MODULE_SERVICE =
	new InjectionToken<ExtraFeatureItemsProvider>(
		'A token for either the vehicle service or the vehicle category service',
	);
